import { BaseSubChain } from 'domain/entities/monomer-chains/BaseSubChain';

export class RnaSubChain extends BaseSubChain {}
